import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { WeekDay } from 'src/app/api/contracts/menu';
import {
  Order,
  OrderPaymentStatus,
  OrderType,
} from 'src/app/api/contracts/order';
import { OrderService } from 'src/app/services/order.service';
import { OrderItemStatus } from 'src/app/types/order';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
})
export class OrderListComponent implements OnInit {
  @Input() public orders!: Order[] | null;
  public readonly orderTypes = OrderType;

  public readonly orderPaymentStatus = OrderPaymentStatus;
  public readonly orderStatuses = OrderItemStatus;
  public readonly orderItemStatuses = OrderItemStatus;

  constructor(private readonly navCtrl: NavController) {}

  ngOnInit() {
    return;
  }

  goToOrderDetails(id: number): void {
    this.navCtrl.navigateForward(`orders/${id}`);
  }

  getOrderDeliveryDays(order: Order): WeekDay[] {
    return Array.from(new Set(order.items.map((item) => item.day)));
  }
}
